var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5123_1701)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21 41.7578C32.0457 41.7578 41 32.8035 41 21.7578C41 10.7121 32.0457 1.75781 21 1.75781C9.9543 1.75781 1 10.7121 1 21.7578C1 32.8035 9.9543 41.7578 21 41.7578Z",
    stroke: "#F9F5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9793 28.9277H18.1992V17.301H21.782L21.8579 18.7025C21.9642 18.6453 22.025 18.631 22.0705 18.5881C23.5279 16.9435 25.9569 16.4572 27.9912 17.4155C29.3272 18.0447 29.8433 19.1888 30.0407 20.4902C30.1469 21.1194 30.1773 21.7629 30.1925 22.4065C30.2076 24.3514 30.1925 26.3106 30.1925 28.2556C30.1925 28.4701 30.1773 28.6703 30.1621 28.9135H26.382C26.382 28.656 26.382 28.4272 26.382 28.1984C26.382 26.4823 26.382 24.7661 26.382 23.05C26.382 22.6639 26.3516 22.2778 26.2909 21.8916C26.1239 20.7046 25.5318 20.1613 24.4387 20.1183C23.1635 20.0754 22.3893 20.6046 22.1312 21.7629C22.0401 22.192 21.9946 22.6496 21.9946 23.1073C21.9793 24.7948 21.9946 26.4966 21.9946 28.1841C21.9946 28.4129 21.9946 28.6417 21.9946 28.9135L21.9793 28.9277Z",
    fill: "#F9F5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 17.9277H16.1992V28.9277H12.1992V17.9277Z",
    fill: "#F9F5EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2129 11.9414C15.3149 11.9414 16.1992 12.8318 16.1992 13.9277C16.1992 15.0236 15.3149 15.9141 14.2129 15.9277C13.0837 15.9277 12.1857 15.0373 12.1994 13.9003C12.2129 12.7907 13.0973 11.9277 14.2129 11.9277V11.9414Z",
    fill: "#F9F5EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5123_1701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.757812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedinicon.b5fdcf6142c9e9e8c4af068adafa0cbd.svg";
export { ForwardRef as ReactComponent };